import { useCallback } from "react";
import { useSnackbar } from "notistack";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@/images/close.svg?react";
import { addDot } from "@/utils/addDot";
import { capitalizeFirstLetter } from "@/utils/capitalizeFirstLetter";
import { isString } from "@/utils/isString";

import { ShowNotification } from "../types/Notifications.types";

const useStyles = makeStyles({
  message: { flex: 1, minWidth: 0 },
});

export const useShowNotification = (): ShowNotification => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const classes = useStyles();

  return useCallback((message, variant, options) => {
    const text = isString(message) ? addDot(capitalizeFirstLetter(message)) : message;

    enqueueSnackbar(<div className={classes.message}>{text}</div>, {
      variant,
      action: (key) => (
        <IconButton aria-label="close" color="inherit" onClick={() => closeSnackbar(key)}>
          <CloseIcon aria-hidden />
        </IconButton>
      ),
      ...options,
    });
  }, [enqueueSnackbar, closeSnackbar, classes]);
};
